import { gql } from '@apollo/client';

export const CREATE_TEAM = gql`
  mutation CreateTeam($request: CreateTeamRequest!) {
    CreateTeam(request: $request) {
      id
    }
  }
`;

export const UPDATE_TEAM_BY_ID = gql`
  mutation UpdateTeam($id: String!, $request: UpdateTeamRequest!) {
    UpdateTeam(id: $id, request: $request) {
      id
    }
  }
`;

export const UPDATE_TEAM_OWNER_BY_TEAM_OWNER = gql`
  mutation UpdateTeamOwnerByTeamOwner(
    $id: String!
    $request: UpdateTeamOwnerByTeamOwnerRequest!
  ) {
    UpdateTeamOwnerByTeamOwner(id: $id, request: $request) {
      id
    }
  }
`;

export const UPDATE_TEAM_OWNER = gql`
  mutation UpdateTeam($id: String!, $request: UpdateTeamRequest!) {
    UpdateTeam(id: $id, request: $request) {
      id
    }
  }
`;

export const CREATE_TEAM_FOR_USER = gql`
  mutation CreateTeamForUser($request: CreateTeamForUserRequest!) {
    CreateTeamForUser(request: $request) {
      id
    }
  }
`;
